import { render, staticRenderFns } from "./PopularMovie.vue?vue&type=template&id=60813969"
import script from "./PopularMovie.vue?vue&type=script&lang=js"
export * from "./PopularMovie.vue?vue&type=script&lang=js"
import style0 from "./PopularMovie.vue?vue&type=style&index=0&id=60813969&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports